<template>
  <!--大赛报名-->
  <div class="apply__main apply">
    <h2 class="main__title">报名信息</h2>
    <div class="main__profile">
      <el-alert
        v-if="detail && detail.detail.status === 1 && detail.detail.status_remark"
        style="width: auto;"
        class="mb20 ml60 mr60"
        :title="detail.detail.status_remark"
        type="error">
      </el-alert>
      <el-form :model="form" ref="profileForm" label-width="0px" :disabled="disabled">
        <el-form-item prop="sign_type" :rules="{ required: true, message: '不能为空'}">
          报名类型
          <el-select v-model="form.sign_type" placeholder="报名类型" @change="changeSignType(arguments[0])">
            <el-option label="高等教育组" :value="1"></el-option>
            <el-option label="职业教育组" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="course_type" :rules="{ required: true, message: '不能为空'}">
          课程分类
          <el-select v-model="form.course_type" placeholder="请选择课程分类" @change="changeForm({course_type: arguments[0]})">
            <el-option label="公共基础课" :value="1"></el-option>
            <el-option label="通识课" :value="2"></el-option>
            <el-option label="专业课" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="monopoly-row" prop="course_name" :rules="{ required: true, message: '不能为空'}">
          课程名称
          <el-input :value="form.course_name" @input="changeForm({'course_name': arguments[0]})"></el-input>
        </el-form-item>
        <el-form-item class="empty-row"></el-form-item>
        <el-form-item prop="teaching_class_total" :rules="{ required: true, message: '不能为空'}">
          授课班级数
          <el-input :value="form.teaching_class_total"
                    @change="changeForm({teaching_class_total: arguments[0]})"
                    @input="changeForm({teaching_class_total: arguments[0]})"
          ></el-input>
        </el-form-item>
        <el-form-item prop="course_class_total" :rules="{ required: true, message: '不能为空'}">
          班级人数
          <el-input type="number"
                    :value="form.course_class_total"
                    @change="changeForm({course_class_total: arguments[0]})"
                    @input="changeForm({course_class_total: arguments[0]})"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item></el-form-item> -->
        <el-form-item prop="activity_major_id" :rules="{ required: true, message: '请选择专业', trigger: 'blur'}">
          专业名称
          <el-cascader
            placeholder="请选择专业名称"
            :options="categoryList"
            v-model="form.activity_major_id"
            :props="{
              value: 'id',
              label: 'name'
            }"
            @change="changeForm({activity_major_id: arguments[0]})"
            filterable
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="activity_major_id" :rules="{ required: true, message: '请选择专业', trigger: 'blur'}">
          专业代码
          <el-input :value="activityMajorId" readonly></el-input>
        </el-form-item>
        <el-form-item prop="author_name" :rules="{ required: true, message: '不能为空'}">
          主要完成人姓名
          <el-input :value="form.author_name" @input="changeForm({author_name: arguments[0]})"></el-input>
        </el-form-item>
        <el-form-item prop="sex" :rules="{ required: true, message: '不能为空'}">
          性别
          <el-select v-model="form.sex" placeholder="请选择性别" @change="changeForm({sex: arguments[0]})">
            <el-option label="男" value="male"></el-option>
            <el-option label="女" value="female"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="nation" :rules="{ required: true, message: '不能为空'}">
          民族
          <el-input :value="form.nation" @input="changeForm({nation: arguments[0]})"></el-input>
        </el-form-item>
        <el-form-item prop="birth_date" :rules="{ required: true, message: '不能为空'}">
          出生年月
          <el-date-picker
            :value="form.birth_date"
            @input="changeForm({birth_date: arguments[0]})"
            align="right"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="id_card" :rules="{ validator: checkPass, trigger: 'blur'}">
          身份证
          <el-input :value="form.id_card" @input="changeForm({id_card: arguments[0]})"></el-input>
        </el-form-item>
        <el-form-item prop="province" :rules="{ required: true, message: '不能为空'}">
          学校所在省份
          <el-select
            clearable
            remote
            placeholder="请选择省份"
            :value="form.province" @input="changeForm({province: arguments[0]})">
            <el-option
              v-for="item in stateList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="degree" :rules="{ required: true, message: '不能为空'}">
          学位
          <el-select v-model="form.degree" placeholder="学位" @change="changeForm({degree: arguments[0]})">
            <el-option label="学士" :value="1"></el-option>
            <el-option label="硕士" :value="2"></el-option>
            <el-option label="博士" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="the_title" :rules="{ required: true, message: '不能为空'}">
          职称
          <el-input :value="form.the_title" @input="changeForm({the_title: arguments[0]})"></el-input>
        </el-form-item>
        <el-form-item prop="duty" :rules="{ required: true, message: '不能为空'}">
          职务
          <el-input :value="form.duty" @input="changeForm({duty: arguments[0]})"></el-input>
        </el-form-item>
        <el-form-item prop="worked_at" :rules="{ required: true, message: '不能为空'}">
          参加工作时间
          <!-- <el-input v-model="form.worked_at"></el-input> -->
          <el-date-picker
            :value="form.worked_at"
            @input="changeForm({worked_at: arguments[0]})"
            align="right"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="professional_field" :rules="{ required: true, message: '不能为空'}">
          专业领域
          <el-input :value="form.professional_field" @input="changeForm({professional_field: arguments[0]})"></el-input>
        </el-form-item>
        <el-form-item prop="teaching_year" :rules="{ required: true, message: '不能为空'}">
          执教年限
          <el-input :value="form.teaching_year" @input="changeForm({teaching_year: arguments[0]})"></el-input>
        </el-form-item>
        <el-form-item prop="mobile" :rules="{ required: true, message: '不能为空'}">
          联系电话
          <el-input :value="form.mobile" @input="changeForm({mobile: arguments[0]})"></el-input>
        </el-form-item>
        <el-form-item prop="email" :rules="{ required: true, message: '不能为空'}">
          电子邮箱
          <el-input :value="form.email" @input="changeForm({email: arguments[0]})"></el-input>
        </el-form-item>
        <el-form-item prop="address" :rules="{ required: true, message: '不能为空'}">
          通信地址
          <el-input :value="form.address" @input="changeForm({address: arguments[0]})"></el-input>
        </el-form-item>
        <el-form-item prop="postcode" :rules="{ required: true, message: '不能为空'}">
          邮编
          <el-input :value="form.postcode" @input="changeForm({postcode: arguments[0]})"></el-input>
        </el-form-item>
        <el-form-item prop="school_id" :rules="{ required: true, message: '不能为空'}">
          所在高校
          <el-select
            v-model="form.school_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteSchoolMethod"
            @change ="selectSchoolChange({
              'school_id': arguments[0],
              'school_college_id': ''
            })"
            :loading="schoolList.state === 'loading'">
            <el-option
              v-for="item in schoolList.list"
              :key="item.id"
              :label="item.full_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item></el-form-item> -->
        <el-form-item prop="school_college_id" :rules="{ required: true, message: '不能为空'}">
          所在高校二级单位
          <el-select
            v-model="form.school_college_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteSecondNameMethod"
            :loading="searchSecondNameLoading"
            :disabled="!form.school_id"
            @change ="changeForm({
              'school_college_id': arguments[0]
            })"
          >
            <el-option
              v-for="item in secondNameList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item></el-form-item> -->
        <el-form-item style="width: 531px" prop="course_stage" :rules="{ required: true, message: '不能为空'}">
          课程开发阶段
          <div class="el-input dib txt-nowrap">
            <el-radio-group v-model="form.course_stage" @change="changeForm({course_stage: arguments[0]})" >
              <el-radio :label="1" border >创意</el-radio>
              <el-radio :label="2" border class="ml20" >提纲</el-radio>
              <el-radio :label="3" border class="ml20" >样章</el-radio>
              <el-radio :label="4" border class="ml20" >完整讲义</el-radio>
              <el-radio :label="5" border class="ml20" >完整资料</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="saveToDraft" plain>暂存</el-button>
          <!--<el-button type="primary"  plain>修改</el-button>-->
          <el-button type="warning"  @click="submitApplyProfile">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {CompetitionSignUpModel} from 'src/model/CompetitionModels';
import {CommonCollegeModel } from 'src/model/CommonModels';

import {
  mapActions,
  mapGetters
} from 'vuex';
import {
  get,
  find,
  each,
  isEmpty,
  extend,
  clone
} from 'lodash';

const LOCAL_STORAGE_KEY = 'ApplyProfile'

export default {
  data () {
    const checkPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('不能为空'));
      }
      setTimeout(() => {
          if (!/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)) {
            callback(new Error('格式错误'));
          } else {
            callback();
          }
      }, 100);
    }
    return {
      checkPass,
      CompliedMajorList:{},
      secondNameList: [],
      searchSecondNameLoading: false
    }
  },
  created () {
    let route = this.$route;
    // 暂存中，如果存在数据时，需要检证是否失效，如果有效，则立即从缓存中恢复
    let revertFromCache = false;
    if (this.hasDraft()) {
      let cache = this.getDraft();
      if (cache.id == route.params.sign_id) {
        revertFromCache = true;
        this.revertDraftToForm();
      } else {
        this.clearDraft();
      }
    }
    // 如果已经添加过活动报名
    if (!this.$route.params.sign_id) {
      this.getSignList({activity_id: route.params.activity_id}).then((response)=>{
        if (get(response, 'list.length', 0)) {
          this.$router.replace({name: 'result_competition_personal'})
        }
      });
    }
    // 获取报名详情信息
    if (this.$route.params.sign_id) {
      this.getSignDetail({sign_id: route.params.sign_id}).then((response)=>{
        // 这个时候，需要还原专业代码
        this.getMajorList({type: response.sign_type}).then(({list}) =>{
          if (revertFromCache) {
            return ;
          }
          let pid = response.activity_major_id;
          let activity_major_id_list = [pid];
          let parent = null;
          while (pid && (parent = find(list, {id: pid}))) {
            if (parent.parent_id) {
              activity_major_id_list.unshift(parent.parent_id);
            }
            pid = parent.parent_id;
          }
          this.changeForm({
            activity_major_id: activity_major_id_list
          });
        });
        if (!revertFromCache) {
          // 把选中的信息，显示到页面
          this.changeForm(extend({}, response, {
            activity_major_id: []
          }));
        }
        // 回显所在高校
        this.remoteSchoolMethod();
        // 回显二级单位
        this.remoteSecondNameMethod();
      }).catch(()=>{
        this.$router.replace({
          name: this.$route.name
        })
      });
    } else if (this.form.sign_type) {
      this.getMajorList({type: this.form.sign_type});
      this.remoteSchoolMethod();

      if (this.form.school_id) {
        this.remoteSecondNameMethod();
      }
    }
    // 获取当前活动的状态
    this.getActivityDetail({activity_id: route.params.activity_id});
  },
  computed: {
    ...mapGetters({
      'detail': 'getUserCompetitionActivitySignDetailGetters',
      'activityDetail': 'getCompetitionActivityDetailGetters',
      'majorList': 'getCompetitionActivityMajorListGetters',
      'form': 'getCompetitionActivitySignApplyFormGetters',
      'signList': 'getUserCompetitionActivitySignListGetters',
      'schoolList': 'getOrganizationsList'
    }),
    //省份列表
    stateList() {
      return ["北京市","天津市","上海市","重庆市","河北省","山西省","辽宁省","吉林省","黑龙江省","江苏省","浙江省",
        "安徽省","福建省","江西省","山东省","河南省","湖北省","湖南省","广东省","海南省","四川省","贵州省","云南省",
        "陕西省","甘肃省","青海省","台湾省","内蒙古自治区","西藏自治区","广西壮族自治区","宁夏回族自治区",
        "新疆维吾尔自治区","香港","澳门",]
    },
    disabled(){
      if (this.$route.params.sign_id) {
        let detail = this.detail.detail;
        return !(detail.status === 1 && detail.updated_at === null);
      }
      return false;
    },
    categoryList () {
      let detail = this.majorList.detail;
      let toTreeFn = function (list, parentId = null) {
        let result = [];
        let current;
        for (let i = 0, j = list.length; i < j; i++) {
          current = list[i];
          if (current.parent_id === parentId) {
            let children = toTreeFn(list, current.id);
            let res;
            if (children.length) {
              res = Object.assign({
                children: children
              }, current)
            } else {
              res = Object.assign({}, current)
            }
            result.push(res)
          }
        }
        return result
      };
      return toTreeFn(get(detail, `${this.form.sign_type}.list`, []))
    },
    // 专业代码
    activityMajorId(){
      let res = get(this, `CompliedMajorList.${this.form.sign_type}`);
      if (isEmpty(res)) {
        if (this.categoryList.length) {
          let result = {};
          each(get(this, `majorList.detail.${this.form.sign_type}.list`, []), function(item){
            result[item.id] = item;
          });
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.CompliedMajorList = extend({}, this.CompliedMajorList, {
            [this.form.sign_type]: result
          });
          res = this.CompliedMajorList[this.form.sign_type];
        }
      }
      let activity_major_id = this.form.activity_major_id;
      if ( activity_major_id && activity_major_id.length && res ) {
        return get(res[activity_major_id[activity_major_id.length-1]], 'code', '');
      }
      return '';
    }
  },
  methods: {
    ...mapActions({
      'getSignDetail': 'actionGetUserCompetitionActivitySignDetail',
      'getActivityDetail': 'actionGetCompetitionActivityDetail',
      'getMajorList': 'actionGetCompetitionMajorList',
      'changeForm': 'actionCompetitionSignApplyFormChange',
      'getSignList': 'actionGetUserCompetitionActivitySignList',
      'getOrganization': 'getOrganizationsSearch',
    }),
    // 更改表单当中，sign_type 的类型
    changeSignType(type){
      this.changeForm({sign_type: type, activity_major_id: []});
      if (type && !get(this, `majorList.detail.${type}.list.length`) ) {
        this.getMajorList({type});
      }
    },
    submitApplyProfile () {
      this.$refs.profileForm.validate(valid => {
        if (valid) {
          this.$confirm('此操作将提交信息至遴选工作组委会，提交成功后，不可以再次修改，是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let query = clone(this.form);
            let params = this.$route.params;
            query.activity_id = params.activity_id;
            query.sign_id = params.sign_id;
            query.activity_major_id = query.activity_major_id[query.activity_major_id.length - 1];
            CompetitionSignUpModel.getInstance().execute(query).then(() => {
              this.clearDraft();
              this.$alert('提交成功!', '提示' ,{
                confirmButtonText: '确定',
                callback:() => {
                  this.$router.push({
                    name: 'result_competition_personal',
                  })
                }
              });
            }).catch(err => {
              // console.log(err)
              this.$message({
                type: 'error',
                message: err.errmsg || '出错了异常，请稍后重试'
              });
              localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this.form));
            });

          }).catch(() => {

          });
        } else {
          this.$message({
            type: 'error',
            message: '请填写完表单！'
          })
        }
      })
    },
    remoteSchoolMethod(searchString=''){
      let query = {
        type: 'school',
        page: 1,
        size: 15,
        keywords: searchString
      }
      if (this.form && this.form.school_id) {
        query.fixed = [this.form.school_id];
      }
      this.getOrganization(query);
    },
    selectSchoolChange(form){
      this.changeForm(form);
      this.remoteSecondNameMethod()
    },
    remoteSecondNameMethod(searchString=''){
      this.searchSecondNameLoading = true;
      let school_id = this.form.school_id;
      let query = {
        id: school_id,
        page: 1,
        size: 15,
        keywords: searchString,
      };
      if (this.form.school_college_id) {
        query.fixed = [this.form.school_college_id];
      }
      CommonCollegeModel.getInstance().execute(query).then(res => {
        this.secondNameList = res.list;
        this.searchSecondNameLoading = false;
      });
    },
    revertDraftToForm(){
      let draft = this.getDraft();
      this.changeForm(draft)
    },
    saveToDraft () {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this.form));
      this.$message({
        type: 'success',
        message: '暂存成功'
      });
    },
    hasDraft () {
      return !isEmpty(localStorage.getItem(LOCAL_STORAGE_KEY));
    },
    clearDraft () {
      localStorage.removeItem(LOCAL_STORAGE_KEY, '')
    },
    getDraft () {
      try {
        return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
        // eslint-disable-next-line no-empty
      } catch (exception){
      }
      return null;
    }
  }
}
</script>
<style scoped>
.apply >>> .el-radio.is-bordered.is-checked,
.apply >>> .el-radio__inner:hover{
  border-color: #67c23a;
}
.apply >>> .el-radio__input.is-checked+.el-radio__label{
  color: #67c23a;
}
.apply >>> .el-radio__input.is-checked .el-radio__inner{
  border-color: #67c23a;
  background: #67c23a;
}
</style>

<style lang="less" scoped>
  @font-title: 24px;
  @font-minor: 18px;
  @font-author-name: 16px;
  @font-primary: 14px;

  @color-white: #fff;
  @color-blue: #648cfc;
  @color-gray: #f5f7fa;
  @color-dark-gray: #909399;
  @color-form: #333;

  .apply__header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    color: @color-white;
    background: @color-blue;
    .header__title{
      margin-left: 21px;
      font-size: @font-minor;
    }
    .header__author{
      display: flex;
      align-items: center;
      margin-right: 33px;
      cursor: pointer;
      .author__avatar{
        width: 48px;
        height: 48px;
        margin-right: 13px;
        border: 1px solid @color-white;
        border-radius: 50%;
      }
      .author__name{
        display: flex;
        align-items: center;
        font-size: @font-author-name;
      }
    }
  }
  .apply__main{
    padding: 0 49px;
    background: @color-gray;
    .main__title{
      margin: 0;
      line-height: 96px;
      font-size: @font-title;
      font-weight: normal;
    }
    .main__profile{
      padding-top: 44px;
      padding-bottom: 170px;
      background-color: @color-white;
      .el-form{
        display: flex;
        flex-wrap: wrap;
        color:  @color-form;
        .el-form-item{
          box-sizing: border-box;
          display: flex;
          justify-content: flex-end;
          &:nth-child(odd){
            width: 45%;
          }
          &:nth-child(even){
            width: 55%;
            padding-right: 142px;
          }
          &:last-child{
            display: flex;
            justify-content: flex-start;
            margin-top: 50px;
            margin-left: 532px;
          }
          .el-input,  .el-cascader,  .el-select{
            width: 350px;
            margin-left: 12px;
          }
          &.monopoly-row{
            width: 88%;
            .el-form-item__content{
              margin-left: 0px;
              padding-right: 142px;
              .el-input{
                width: 857px;
              }
            }
          }
          &.empty-row{
            width: 0;
            padding: 0;
          }
        }
        .form__steps{
          display: flex;
          align-items: center;
          margin-left: 79px;
          .steps{
            margin-left: 27px;
            color: @color-dark-gray;
            .steps__number{
              display: inline-block;
              width: 24px;
              height: 24px;
              margin-right: 15px;
              border: 1px solid;
              border-radius: 50%;
              line-height: 24px;
              text-align: center;
              font-style: normal;
            }
            .steps__icon{
              margin: 0 12px;
            }
          }
        }
      }
    }
  }
</style>
